import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Table from '../controls/table/table.jsx';
import { actionCards } from '../../actions/cards_actions.jsx';
import { withTranslation } from 'react-i18next';
import Loader from '../controls/loader/loader.jsx';

const Columns = [
    {
        header: "Cards.cardNumber",
        name: "cardNumberInternal",
        sortProperty: "CardNumberInternal"
    },
    {
        header: "Cards.userName",
        name: "userName",
        sortProperty: "UserName"
    },
    {
        header: "Cards.car",
        name: "car",
        sortProperty: "Car"
    },
    {
        header: "Cards.description",
        name: "description",
        sortProperty: "Description"
    }
];

class CardList extends React.Component {
    constructor(props) {
        super(props);
        this.getData = this.getData.bind(this);
        this.addCard = this.addCard.bind(this);
        this.editCard = this.editCard.bind(this);
        this.getFilteredItems = this.getFilteredItems.bind(this);
    }
    

    componentDidMount() {
        this.getData();
    }

    getData(filter) {
        filter = filter ? filter : this.props.filter;
        this.props.getCards(filter);
    }

    addCard() {
        this.props.history.push('/cards/addCard');
    }

    editCard(card) {
        this.props.history.push('/cards/editCard/' + card.cardId);
    }

    getFilteredItems(modelFilter) {
        let filter = this.props.filter;
        filter.modelFilter = modelFilter;
        this.getData(filter);
    }
    
    render() {
        let modelFilter = {
            cardNumber: {
                name: "cardNumberInternal",
                type: "string",
                header: this.props.i18n.t('Cards.cardNumber'),
                value: this.props.filter.modelFilter.cardNumberInternal
            },
            userName: {
                name: "userName",
                type: "string",
                header: this.props.i18n.t('Cards.userName'),
                value: this.props.filter.modelFilter.userName
            }
        };

        return (
            <div>
                <Table settings={{
                    columns: Columns,
                    items: this.props.cards,
                    itemsFilter: Object.assign({}, this.props.filter, { filterProps: modelFilter }),
                    isEditable: true,
                    getItemsFunction: this.getData,
                    addItemFunction: this.addCard,
                    editItemFunction: this.editCard
                }} />
                {this.props.loading && <Loader/>}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        cards: state.cards.cards,
        filter: state.cards.filter,
        loading: state.cards.loading,
        errors: state.cards.errors,
        forceReload: state.cards.forceReload
    };
}

export default connect(
        mapStateToProps,
        dispatch => bindActionCreators(actionCards, dispatch)
)(withTranslation('translantions')(CardList));